import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'trash-bin-icon',
  templateUrl: './trash-bin-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TrashBinIconComponent {}
